import { render, staticRenderFns } from "./StudipTreeTable.vue?vue&type=template&id=3101b402&"
import script from "./StudipTreeTable.vue?vue&type=script&lang=js&"
export * from "./StudipTreeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports